import React from "react";
import { InstallmentSelectorContainer } from "./style";
const InstallmentSelector = ({ installments, onChange, selected }) => {
  return (
    <InstallmentSelectorContainer>
      <h5>انتخاب تعداد اقساط</h5>
      {installments.map((installment) => (
        <div
          className={`item ${selected?.id === installment.id ? "selected" : ""}`}
          key={installment.id}
          onClick={() => onChange({ installment: installment })}
        >
          <div className="title-area">{installment.title}</div>
        </div>
      ))}
    </InstallmentSelectorContainer>
  );
};
export default InstallmentSelector;
